import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Field from "../shared/Field";
import ItemCard from "../shared/ItemCard";
import AddItemBtn from "../shared/AddItemBtn";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormCaseStudies = ({ data, onChange, onOpenCaseStudyModal }) => {
  const updateItem = (i, field, value) => {
    const items = [...data.items];
    items[i] = { ...items[i], [field]: value };
    onChange({ ...data, items });
  };

  const addItem = () =>
    onChange({
      ...data,
      items: [
        ...data.items,
        { title: "", category: "", siteUrl: "", thumbnailUrl: "" },
      ],
    });

  const removeItem = (i) =>
    onChange({ ...data, items: data.items.filter((_, idx) => idx !== i) });

  return (
    <Box>
      <Field
        label="Section Title"
        value={data.sectionTitle}
        onChange={(v) => onChange({ ...data, sectionTitle: v })}
      />
      {data.items.map((item, i) => (
        <ItemCard
          key={i}
          index={i}
          label="Case Study"
          onDelete={() => removeItem(i)}
        >
          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Field
              label="Project Title"
              value={item.title}
              onChange={(v) => updateItem(i, "title", v)}
              placeholder="Embracing Nature School"
            />
            <Field
              label="Category"
              value={item.category}
              onChange={(v) => updateItem(i, "category", v)}
              placeholder="E-Commerce Platform"
            />
          </Box>
          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Field
              label="Site URL"
              value={item.siteUrl}
              onChange={(v) => updateItem(i, "siteUrl", v)}
              placeholder="https://example.com"
            />
            <ImageUploadField
              label="Thumbnail"
              value={item.thumbnailUrl}
              onChange={(v) => updateItem(i, "thumbnailUrl", v)}
            />
          </Box>

          {!item.caseStudyId ? (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => onOpenCaseStudyModal(i)}
              fullWidth
              sx={{
                mt: 1.5,
                borderStyle: "dashed",
                borderColor: "#667eea",
                color: "#667eea",
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": {
                  borderStyle: "dashed",
                  borderColor: "#764ba2",
                  color: "#764ba2",
                  background: "rgba(102,126,234,0.08)",
                },
              }}
            >
              Add Project Details
            </Button>
          ) : (
            <Box
              mt={1.5}
              p={1}
              sx={{
                background: "rgba(46,125,50,0.1)",
                borderRadius: "8px",
                border: "1px solid rgba(46,125,50,0.3)",
              }}
            >
              <Typography variant="caption" color="success.main">
                ✓ Details saved · /case/{item.slug}
              </Typography>
            </Box>
          )}
        </ItemCard>
      ))}
      <AddItemBtn label="Add Case Study (Project)" onClick={addItem} />
    </Box>
  );
};

export default FormCaseStudies;
